import * as React from "react"
import Seo from "@components/seo"
import Layout from "@layout"
import Header from "@layout/header/header-one"
import Footer from "@layout/footer/footer-one"
import JournalsArea from "@containers/journals-area"
import Banner from "@components/banners/Ai";


const JournalsPage = ({pageContext, location }) => (
  <Layout location={location}>
    <Seo title="Publications of SCI/SSCI Journals" />
    <Header />
    { <Banner
			pageContext={pageContext}
			location={location}
			title="The Publications of SCI/SSCI Journals"
		/> }
    <main className="site-wrapper-reveal">
      <JournalsArea />
    </main>
    <Footer />
  </Layout>
)

export default JournalsPage
